import React from 'react';

import TextBlock from '../Components/TextBlock';

const Prise = (props) => {
	return (
		<TextBlock name='Вартість послуг'>
            <section className="s-text">
                <table>
                <tbody>
                    <tr> 
                        <td>Консультації</td> 
                        <td> від 200 гривень</td> 
                    </tr>
                    <tr> 
                        <td>Розробка договорів</td> 
                        <td>від 1000 гривень</td> 
                    </tr>
                    <tr> 
                        <td>Реєстрація юридичних осіб</td> 
                        <td>від 1500 гривень</td> 
                    </tr>
                    <tr> 
                        <td>Внесення змін для юридичних осіб</td> 
                        <td>від 2500 гривень</td> 
                    </tr>
                    <tr> 
                        <td>Реєстрація приватних  підприємців (ФОП)</td> 
                        <td>від 1000 гривень</td> 
                    </tr>
                    <tr> 
                        <td> Внесення змін для ФОП</td> 
                        <td>від 500 гривень</td> 
                    </tr>
                    <tr> 
                        <td>Припинення ФОП</td> 
                        <td>від 500 гривень</td> 
                    </tr>
                    <tr> 
                        <td>Отримання документів від державних органів</td> 
                        <td>від 500 гривень</td> 
                    </tr>
                    <tr> 
                        <td>Отримання ліцензій</td> 
                        <td>від 3000 гривень</td> 
                    </tr>
                    <tr> 
                        <td>Питання інтелектуальної власності</td> 
                        <td>від 1000 гривень</td> 
                    </tr>
                    <tr> 
                        <td>Реєстрація  РРО/ПРРО </td> 
                        <td>від 1000 гривень</td> 
                    </tr>
                    <tr> 
                        <td>Ліквідація юридичних осіб</td> 
                        <td>від 14000 гривень</td> 
                    </tr>
                    <tr> 
                        <td>Готові фірми</td> 
                        <td>від 3000 гривень</td> 
                    </tr>
                    </tbody>
                </table>
            </section>
        </TextBlock>

	);
}

export default Prise;


// WEBPACK FOOTER //
// ./src/Page/Prise.jsx